import Lottie from 'react-lottie'
import animationData from '../../assets/hero_animation/Web Design Layout.json'
const LottieComponent = () => { 
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    return (
      <div className="lottie-container">
        <Lottie options={defaultOptions} />
      </div>
    );
}

export default LottieComponent